import { CodeBlock } from "@altimateai/lego";
import { ConversationGroup } from "./context/types";
import classes from "../../details/styles.module.scss";

const ConversationHighlightText = ({
  meta: { highlight: text, filePath, field, column },
}: {
  meta: ConversationGroup["meta"];
}) => {
  if (!text) {
    return null;
  }

  const path = column ? `${filePath} (${column})` : filePath;

  return (
    <div className={classes.highlightText}>
      <CodeBlock
        code={text}
        language={field ? "markdown" : "sql"}
        // show line numbers only for sql
        showLineNumbers={!field}
        fileName={path}
        theme="light" // TODO: fix this
      />
    </div>
  );
};

export default ConversationHighlightText;
